// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__pPV-s","hack_logo":"Hero_hack_logo__mBZs6","event_date":"Hero_event_date__RFLX4","become_partner_btn":"Hero_become_partner_btn__N3waP"};